import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

let onUnauthorized = () => {};
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

http.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  const isAuthCall = cfg?.url?.startsWith("/auth/");
  if (error.response?.status === 401 && !cfg._retried && !isAuthCall) {
    cfg._retried = true;
    try {
      await http.post("/auth/refresh");
      return http(cfg);
    } catch {
      onUnauthorized();
    }
  }
  return Promise.reject(error);
});

export const fmtDate = (utc) =>
  new Date(utc).toLocaleString("it-IT", { weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Errore imprevisto";
};

export const tname = (t) => t?.shortName || t?.name || "?";

let brandingPromise;
export const getBranding = () => (brandingPromise ||= http.get("/branding").then((r) => r.data));
